import { useQuery } from 'react-query';
import { extractLogoUrl, getPublicTmaBranding } from '../helpers/tmaBrandingHelper';
import logger from '../utils/logger';
import { TMA_PUBLIC_BRANDING } from '../constants/queryKeys';
import defaultLogo from '../assets/images/onsolt_logo.png';

// Web logo for the pages shown before login, from the public branding API.
// Falls back to the bundled logo when none is set or the request fails;
// isLoading lets the page hold the logo slot empty instead of flashing the default first.
export function usePublicBrandingLogo() {
    const brandingQuery = useQuery({
        queryKey: TMA_PUBLIC_BRANDING,
        queryFn: getPublicTmaBranding,
        onError: (error) => logger.error('Failed to fetch public TMA branding', error),
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: Infinity,
    });

    const webLogo = extractLogoUrl(brandingQuery.data?.data?.data?.webLogo);

    return {
        logo: webLogo ?? defaultLogo,
        isLoading: brandingQuery.isLoading,
    };
}
